import PropTypes from "prop-types";
import React from "react";
import { Box, Spacer } from "orcs-design-system";

import GroupsNavigationLoader from "src/components/GroupsNavigation";
import { useWorkspaceTagConfig } from "src/contexts/global/WorkspaceContext";

import TagTypeNavigation from "src/components/TagTypeNavigation";

const ExploreMenu = ({ groupsNavProps }) => {
  const tagTypesConfig = useWorkspaceTagConfig();

  // Get all tag types that should be shown in explore
  const tagTypes = Object.values(tagTypesConfig || {}).filter(
    (config) => config?.showInExplore
  );

  return (
    <Box>
      <Spacer mb="r">
        <Spacer mb="r">
          <GroupsNavigationLoader {...groupsNavProps} />
        </Spacer>

        {tagTypes.map((tagType) => (
          <Spacer key={tagType.id} mt="xl" mb="r">
            <TagTypeNavigation tagType={tagType} isSelected={false} />
          </Spacer>
        ))}
      </Spacer>
    </Box>
  );
};

ExploreMenu.propTypes = {
  groupsNavProps: PropTypes.object,
};

export default ExploreMenu;
